// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"q3a4B","input-container":"Yq9By","input-suffix":"krTi4","numeric":"u8zdb","input":"qkzFW"};